import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ErrorBoundary from './components/ErrorBoundary';

// Global error handler for uncaught errors
window.onerror = function(message, source, lineno, colno, error) {
  console.error('Global error:', { message, source, lineno, colno, error });
  // Show error on page if React hasn't mounted yet
  const root = document.getElementById('root');
  if (root && !root.hasChildNodes()) {
    root.innerHTML = `
      <div style="padding: 20px; text-align: center; font-family: sans-serif;">
        <h1 style="color: #dc2626;">App Error</h1>
        <p>${message}</p>
        <button onclick="location.reload()" style="padding: 10px 20px; margin-top: 10px;">Reload</button>
      </div>
    `;
  }
  return false;
};

// Handle unhandled promise rejections
window.onunhandledrejection = function(event) {
  console.error('Unhandled promise rejection:', event.reason);
};

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Don't refetch on window focus
      staleTime: 30000, // Data is fresh for 30 seconds
      retry: 1, // Retry failed requests once
    },
  },
});

try {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  // Mark app as loaded for the HTML fallback script
  window.__APP_LOADED__ = true;

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );

} catch (error) {
  console.error('Failed to render app:', error);
  document.body.innerHTML = `
    <div style="padding: 20px; text-align: center; font-family: sans-serif; background: #0C3E71; color: white; min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center;">
      <h1>Failed to start app</h1>
      <p>${error.message}</p>
      <button onclick="location.reload()" style="padding: 10px 20px; margin-top: 10px; border: none; background: white; color: #0C3E71; border-radius: 8px; cursor: pointer;">Reload</button>
    </div>
  `;
}
